import { createSelector } from 'reselect';

export const getAppData = (state) =>
    state.app;

export const isLoadingApp = (state) => getAppData(state).isLoading;

// export const getPageSeoMetadataWithStatus = createSelector(
//     getPageSEOMetadata,
//     getLoadPageSEOMetadataStatus,
//     (data = {}, status = {}) => ({ ...data, ...status }),
// );